// TrailDog branded assets
// LOGO_URL — the round green main logo (dog · compass · mountain). Served
// locally from /public so preview + production always resolve without a
// dependency on the customer-assets CDN. Bumped path when refreshing the
// artwork so PWA + browser caches invalidate cleanly.
export const LOGO_URL = "/traildog-logo.png?v=2";
export const DEFAULT_AVATAR_URL = "https://customer-assets.emergentagent.com/job_discover-walks-1/artifacts/ecqf9h1f_default%20profile%20image.png";
